import Vue from "vue";

export const DatabankState = {
  currentDatabank: {
    id: 0,
    name: "",
    description: "",
    created_at: "",
    updated_at: "",
    total_targets: 0,
    import_status: "",
    total_curriculums: 0
  },
  databank: null,
  databanks: [],
  totalDatabanks: 0
};

export const DatabankGetters = {
  currentDatabank: state => {
    return state.currentDatabank;
  },
  databank: state => {
    return state.databank;
  },
  databanks: state => {
    return state.databanks;
  },
  totalDatabanks: state => {
    return state.totalDatabanks;
  }
};

export const DatabankMutations = {
  setCurrentDatabank: (state, data) => {
    if (data) {
      const index = state.databanks.findIndex(
        i => Number(i.id) === Number(data.id)
      );
      if (index > -1) {
        const arr = [...state.databanks];
        arr[index] = data;
        Vue.set(state, "databanks", arr);
      }
      if (state.databank && Number(data.id) === Number(state.databank.id)) {
        Vue.set(state, "databanks", data);
      }
    }
    Vue.set(state, "currentDatabank", data);
  },
  setDatabank: (state, data) => {
    if (data) {
      const index = state.databanks.findIndex(
        i => Number(i.id) === Number(data.id)
      );
      if (index > -1) {
        const arr = [...state.databanks];
        arr[index] = data;
        Vue.set(state, "databanks", arr);
      }
      if (Number(data.id) === Number(state.currentDatabank.id)) {
        Vue.set(state, "currentDatabanks", data);
      }
    }
    Vue.set(state, "databank", data);
  },
  setDatabanks: (state, data) => {
    Vue.set(state, "databanks", data.databanks);
    Vue.set(state, "totalDatabanks", data.total_count);
  },
  addDatabank: (state, data) => {
    Vue.set(state, "databanks", [data, ...state.databanks]);
    Vue.set(state, "totalDatabanks", state.totalDatabanks + 1);
  },
  removeDatabank: (state, data) => {
    const arr = state.databanks.filter(i => Number(i.id) !== Number(data.id));
    Vue.set(state, "databanks", arr);
    Vue.set(state, "totalDatabanks", state.totalDatabanks - 1);
  }
};

export const DatabankActions = {
  getCurrentDatabank: ({ commit, dispatch }) => {
    return Vue.axios.secured
      .get(`/api/v1/databank`)
      .then(response => {
        commit("setCurrentDatabank", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch current databank from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },

  importDatabank: ({commit, dispatch}, data = {}) => {
    return Vue.axios.secured
      .post("/api/v1/databanks/import", { databank: data.databank, center_id: data.center_id })
      .then(response => {
        commit("addDatabank", response.data);
        const title = "Import databank success!";
        const message = "Success! A new databank has been import.";
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to databank from center.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateCurrentDatabank: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/databank`, data)
      .then(response => {
        commit("setCurrentDatabank", response.data);
        const title = data.title || "Settings updated";
        const message =
          data.message || "Success! The information has been updated.";
        dispatch("showToast", { title, message, type: "success" });
        dispatch("checkCurrentUser");
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update current databank.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  //
  getDatabanks: ({ commit, dispatch }, data = {}) => {
    const params = data.params || "";
    return Vue.axios.secured
      .get(`/api/v1/databanks${params}`)
      .then(response => {
        commit("setDatabanks", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch databanks from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  getDatabank: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .get(`/api/v1/databanks/${data.id}`)
      .then(response => {
        commit("setDatabank", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch databank from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  createDatabank: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post("/api/v1/databanks", { databank: data.databank })
      .then(response => {
        commit("addDatabank", response.data);
        const title = "New databank created";
        const message = "Success! A new databank has been created.";
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to databank from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateDatabank: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/databanks/${data.id}`, { databank: data.databank })
      .then(response => {
        commit("setDatabank", response.data);
        const title = data.title || "Databank updated";
        const message = data.message || "Success! The databank has been updated.";
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update databank.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  deleteDatabank: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/databanks/${data.id}`)
      .then(response => {
        commit("removeDatabank", data);
        const title = "Databank deleted";
        const message = `Success! ${data.name} has been deleted.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to delete databank.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/databank.store.js